import { useEffect } from "react";

const Terms = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);

  return (
    <div className="terms">
      <h1>TÉRMINOS Y CONDICIONES</h1>

      <span>----</span>

      <p>
        Al hacer click en Aceptar, usted estará aceptando los presentes términos
        y condiciones de la operativa Campo Mercado, y se obliga en todos sus
        términos, sin excepción. Campo Mercado (RITERY S.A.) cuenta siempre con
        el derecho de modiﬁcar los presentes Términos y Condiciones, para lo
        cual alcanzará con notiﬁcar a los usuarios de los cambios realizados,
        con al menos 10 días hábiles de preaviso. Transcurrido dicho período
        luego de la notiﬁcación de cambio, si el usuario continuase utilizando
        el sistema, entonces se entenderá que ha aceptado tácitamente los
        cambios realizados. En la medida que un usuario no utilice la plataforma
        de compra y venta de ganado, no tendrá responsabilidades frente a Campo
        Mercado, más allá de la obligación de brindar información verdadera al
        momento de registrarse y en cualquier instancia posterior.
      </p>

      <h2>SECCIÓN 1 - COMISIONES</h2>

      <p>
        Los gastos en compras o ventas de ganado por concepto de comisión son de
        3% más impuestos para cada parte (comprador y vendedor) para las
        operaciones al contado. Nuestras operaciones están avaladas por el
        Fideicomiso de Garantía Campo Mercado. El porcentaje se calculará sobre
        el valor ﬁnal del lote.
      </p>

      <h2>SECCIÓN 2 - USUARIO</h2>

      <p>
        Para operar en Campo Mercado, es necesario que el usuario se registre y
        complete su perﬁl de usuario.
      </p>

      <h2>SECCIÓN 3 - VENDER GANADO</h2>

      <p>
        Ingreso de datos básicos del lote: Una vez que el perﬁl del usuario se
        encuentre registrado, el usuario puede ingresar datos básicos del lotes
        que tenga interés en vender y publicar.
      </p>

      <p>
        Seguimiento del lote: El lote del usuario publicado, quedará asociado a
        el respectivo usuario y éste podrá hacer un seguimiento de las visitas
        que tiene en el sistema y podrá recibir ofertas.
      </p>

      <p>
        Ofertas: Las ofertas podrán ser aceptadas o rechazadas, el criterio de
        aceptación o rechazo quedará a sola discreción del usuario vendedor.
      </p>

      <p>
        Concreción de la venta: Una vez se concrete una compra, el lote
        correspondiente será retirado como lote ofrecido.
      </p>
      <p>
        Visita del certiﬁcador: Una vez cerrado el negocio éste queda sujeto a
        certificación. Es decir que el negocio se mantiene en caso de que el
        informe realizado por vendedor se condiga con lo evaluado en la
        posterior certificación. Uno de los certiﬁcadores habilitados se
        comunicará con el usuario para concretar una visita. En la visita se
        recabará la información necesaria para validar la información del lote
        (pesos, características, sanidad, trazabilidad, etc). Una vez
        inspeccionado el lote, el certiﬁcador preparará un listado de los
        animales con las características relevantes, en caso de coincidir con lo
        informado por el vendedor el negocio queda oficialmente cerrado, en caso
        de que en la certificación surjan diferencias con respecto a lo
        publicado el lote se vuelve a renegociar. En caso de dar de baja un
        negocio cerrado tanto el comprador como vendedor, deberá abonar UDS 2
        por animal mas UDS 100 por lote. Asimismo Campo Mercado se reserva el
        derecho de rechazar el lote por razones de calidad, raza u otras
        razones, incluyendo razones de oportunidad o razones comerciales, sin
        responsabilidad.
      </p>

      <p>
        Concreción de la venta: Una vez se concrete una compra y se concrete la
        certificación, el lote correspondiente será retirado como lote ofrecido.
        Campo Mercado se comunicará con el comprador y el vendedor, para
        coordinar el pago y la entrega.
      </p>

      <p>
        El usuario oferente que hubiese solicitado la venta de su lote debe
        estar en condiciones de entregar el ganado y suscribir las guías (y
        realizar cualquier acto necesario para la transferencia del mismo,
        incluyendo la autorización sanitaria para el traslado ) dentro de las 48
        horas contadas desde la visita del certiﬁcador y hasta que el mismo sea
        entregado o hasta que el lote sea retirado de la venta (en caso de no
        haberse vendido).
      </p>

      <p>
        Cuando tras 14 días corridos un lote no hubiese podido ser vendido, el
        mismo se dará de baja. Campo Mercado se reserva el derecho de no admitir
        nuevamente el lote para la venta mediante su Sistema.
      </p>

      <h2>SECCIÓN 4 - COMPRAR GANADO</h2>

      <p>
        Cualquier usuario registrado podrá presentar ofertas para comprar ganado
        online mediante el Sistema Campo Mercado.
      </p>

      <p>
        Los usuarios podrán realizar ofertas, la cual si es aceptada por el
        usuario vendedor dentro de las 24 horas desde que se inició la primera
        oferta, estará asumiendo el compromiso de la operación de compra.
      </p>

      <p>
        Haciendo click en “enviar oferta” el usuario estará aceptando la oferta
        de venta, con todos sus términos y condiciones incluyendo el precio,
        asumiendo el compromiso de la operación. En caso de querer realizar una
        oferta sujeta a determinadas condiciones el usuario debe realizar la
        oferta a través del representante comercial de su zona.
      </p>

      <h2>SECCIÓN 5 - SERVICIO LOGÍSTICO</h2>

      <p>
        Campo Mercado brinda la gestión del servicio logístico para realizar los
        traslados de animales. Campo Mercado no asume ninguna obligación.
      </p>

      <h2>SECCIÓN 6 - CERTIFICADORES</h2>

      <p>
        Todos los lotes que sean vendidos a través de Campo Mercado serán
        posteriormente inspeccionados por certiﬁcadores habilitados y
        contratados por Campo Mercado.
      </p>

      <h2>SECCIÓN 7 - CANTIDADES MÍNIMAS</h2>

      <p>
        Para las categorías de pieza de cría la cantidad mínima de cabezas por
        lote será de 40, y para el resto de las categorías la cantidad mínima de
        cabezas será de 25, existiendo para ambos casos una tolerancia de 10%
        menos luego de inspeccionado el lote.
      </p>

      <h2>SECCIÓN 8 - INFORMACIÓN DE LOS LOTES</h2>

      <p>
        Todos los lotes deberán tener la siguiente información; nombre del
        propietario —el que no estará publicado en el Sistema—, ubicación, raza,
        sexo, estado reproductivo, categoría correspondiente, peso, fecha de
        inspección, e informe de trazabilidad. Los lotes deberán ser uniformes y
        de calidad, pudiendo ser de razas de carne puras y sus cruzas o de razas
        lecheras. Campo Mercado tendrá el derecho de rechazar animales
        individuales o lotes, a su sola discreción y sin responsabilidad.
      </p>

      <p>
        Las categorías de invernada serán ofrecidos en UDS/kg mientras que las
        categorías de piezas cría o vientres preñados serán ofrecidas en
        UDS/animal.
      </p>

      <h2>SECCIÓN 9 - PESOS</h2>

      <p>
        Los kilos de los ganados certiﬁcados, son kilos brutos y podrán variar
        según el tiempo transcurrido de la fecha de inspección y carga, forraje
        consumido y época del año. Se aceptará por el Sistema y los usuarios una
        tolerancia en más o menos de un 10% (salvo que se indique lo contrario
        en las condiciones particulares de cada lote). En los casos en que se
        vende por animal, la variación no afecta el precio, siempre que se
        encuentre dentro del límite de tolerancia.
      </p>

      <p>
        Una vez concretada la operación compra/venta los animales se pesarán en
        las balanzas oﬁcial más cercana al campo del productor vendedor
        (idealmente de camino al campo del comprador). El destare varía
        dependiendo de la distancia entre el embarcadero y la balanza, a razón
        de: 0-70 km 6%, 71-150 km 5%, 151 km en adelante 4%. Se compensará 0,4
        kg/km recorrido de ida y vuelta por camión. Los costos de pesada corren
        por cuenta de Campo Mercado.
      </p>

      <p>
        Cuando las variaciones de pesada, destare, o demás elementos previstos
        en estos Términos y Condiciones estén por fuera de los rangos
        permitidos, o cuando se constatare que los animales a entregarse no
        fueran los detallados en la oferta, la operación se resolverá, debiendo
        restituirse los pagos y entregarse el ganado para volver a la situación
        anterior a la misma; y debiendo pagar el productor vendedor, UDS 2 por
        animal mas UDS 100 por lote, y cualquier otro gasto ocasionado a la
        parte compradora.
      </p>

      <h2>SECCIÓN 10 - PREÑEZ</h2>

      <p>
        Para los ganados con preñez garantizada el comprador deberá aceptar una
        tolerancia de hasta un 4% de animales fallados.
      </p>

      <h2>SECCIÓN 11 - PLAZOS</h2>

      <p>
        El comprador dispondrá de un plazo de 10 días calendario para retirar el
        lote desde que se le notiﬁcó que adquirió el lote. El ganado deberá
        cargarse siempre en la mañana (antes de las 11 am) salvo que las partes
        acuerden lo contrario. En el caso en que el ganado no estuviere
        disponible en el día y hora convenido (siempre dentro de los 10 días
        calendario) el comprador tendrá derecho de resolver el contrato y dar de
        baja la operación, debiendo pagar el productor vendedor UDS 2 por animal
        y UDS 100 por lote mas cualquier otro gasto ocasionado. En caso que el
        comprador no retire el ganado vencido el plazo deﬁnido, el vendedor
        podrá pesar los ganados en el establecimiento, no siendo responsable de
        la mortandad o pérdida de kg post pesada.
      </p>

      <h2>SECCIÓN 12 - PAGOS</h2>

      <p>
        El pago del ganado comprado se deberá realizar hasta un máximo 3 días
        hábiles luego de recibida la liquidación del ganado cuando la operación
        sea al contado; o del modo en que se pacte en la operación
        correspondiente cuando la misma sea ﬁnanciada. Las obligaciones de la
        compraventa podrán estar garantizadas por medio de un contrato de
        Fideicomiso, cuando así se establezca en la operación particular, en
        cuyo caso se estará a las reglas allí indicadas.
      </p>

      <p>
        Los costos de despacho de tropa y guías deberán ser abonados por el
        vendedor. Finalizado el pago del lote, el comprador deberá haber
        remitido la guía a Campo Mercado para que este confeccione y remita la
        guía deﬁnitiva de cambio de propiedad.
      </p>

      <h2>SECCIÓN 13 - OFERTAS</h2>

      <p>
        Una vez que un lote ofrecido hubiese recibido una aceptación de oferta a
        dicho precio, entonces ni el vendedor ni el comprador tendrán derecho a
        retractarse. La negación a comprar y/o a vender, o a transferir la
        titularidad del ganado o a realizar el pago en los términos acordados
        por medio del Sistema Campo Mercado, impondrá a la parte incumplidora
        una multa equivalente al 10% del valor acordado del lote, a abonarse a
        Campo Mercado dentro de los siguientes 3 días corridos, sin perjuicio de
        las acciones legales que puedan corresponder así como los reclamos por
        daños y perjuicios, la resolución del contrato, o la acción de ejecución
        forzada de la causa, todo ello acumulable con la multa antedicha. La
        misma consecuencia acarreará el hecho de ofrecer en venta un ganado que
        ya no exista o que no tenga las características previstas, o que tenga
        guías y/o trazabilidad falseadas, o cuya titularidad no sea del usuario
        oferente.
      </p>

      <p>
        En todos los casos en que se pacten pagos a realizarse, el no
        cumplimiento del pago de los mismos en plazo hará incurrir al deudor en
        mora de forma automática y se generarán intereses moratorios a la máxima
        tasa permitida por la normativa aplicable.
      </p>

      <h2>SECCIÓN 14 - COMUNICACIÓN</h2>
      <p>
        Cualquier notiﬁcación podrá realizarse a las casillas de correo
        electrónico de las partes declaradas por las mismas.
      </p>

      <span>----</span>
    </div>
  );
};

export default Terms;
